// @ts-nocheck TODO

import {html} from "lit";
import {customElement, property, state} from "lit/decorators.js";
import {classMap} from "lit/directives/class-map.js";
import {unsafeHTML} from "lit-html/directives/unsafe-html.js";
import {initDrag, removeDrag} from "./drag_utils.js";

import Utils from "../../../main/utils/index.js";
import "./AnnotationHeader.js";
import "./AnnotationFooter.js";
import "../../common/controls-inputs/rich-text-editor/RichTextEditor.js";
import UI_MODES from "../ui_modes.js";
import {MobxLitElement} from "@adobe/lit-mobx";
import {annotationStyles} from "./Annotation.styles.js";
import {annotationImageStyles} from "./AnnotationImage.styles.js";
import {loadingBoxStyles} from "../../common/LoadingBox.styles.js";
import Data from "../../../main/data/index.js";
import Integration from "../../../integrations/integration/index.js";

@customElement("pn-annotation-image")
export class AnnotationImage extends MobxLitElement {
	@property()  annotation = {
		comment: null,
		uuid:    null
	};
	@property() topic = {};
	@property() createdByName = "";
	@property() openImageAnnotation = () => {};
	@property() sortBy = "topic";
	@property() mode:       UI_MODES;
	@property() isEditable: boolean;

	@state() x = 0;
	@state() y = 0;

	static styles = [
		// Keep loadingBoxStyles first so some of its styles are overwritten
		loadingBoxStyles,
		annotationStyles,
		annotationImageStyles
	];

	firstUpdated() {
		if (this.mode === UI_MODES.SIDEBAR_DRAG) {
			initDrag(this, {
				annotationUuid: this.annotation.uuid,
				type:           "image",
				thumbnailSrc:   this.getThumbnailUrl()
			});
		}
	}

	updated(changedProperties) {
		// TODO: improve conditional
		if (changedProperties.has("mode") && this.mode !== UI_MODES.SIDEBAR_DRAG) {
			// const prevMode = changedProperties.get("mode");
			// console.log(prevMode, this.mode);
			removeDrag(this.annotation.uuid);
		}
	}

	getThumbnailUrl() {
		if (this.annotation.force_image_url)
			return this.annotation.force_image_url;

		try {
			if (this.annotation.file_status !== "ok")
				return null;

			const key = Utils.File.getFileKey(Data.app.accessToken, this.annotation.file_hash);
			const thumbnailSrc = `${Data.app.config?.urls.pn_files_api}annotation/${this.annotation.uuid}/100x100?key=${key}`;

			return thumbnailSrc;
		} catch (e) {
			console.error("getThumbnailUrl(): ", e);
		}
	}

	getThumbnail() {
		switch (this.annotation?.file_status) {
			case "ok":
				return html`<img
					alt="Annotation image thumbnail"
					class="thumbnail"
					src=${this.getThumbnailUrl()}
				/>`;

			case "pending":
				return html`<span class="thumbnail thumbnail-loading">
					<span class="loading-box">
						<span class="animation">
							<span class="animation-item animation-item-1"></span>
							<span class="animation-item animation-item-2"></span>
							<span class="animation-item animation-item-3"></span>
							<span class="animation-item animation-item-4"></span>
						</span>
						Loading
					</span>
				</span>`;

			default:
				return html`<span class="thumbnail thumbnail-error">
					<span class="error-box">
						<i class="icon-exclamation-circle icon-mask"></i>
						Error
					</span>
				</span>`;
		}
	}

	render() {
		const {annotation, openImageAnnotation} = this;
		const uuid = annotation.uuid;

		const noteContent = annotation.comment ? annotation.comment : "<p></p>";

		const editable = this.mode === UI_MODES.SIDEBAR;

		return html`
			<div role="listitem"
				class="${classMap({
					"annotation-list-item":              true,
					"annotation-image":                  true,
					"js-aa-topic-annotation":            true,
					"mode-sidebar-drag":                 this.mode === UI_MODES.SIDEBAR_DRAG,
					["integration-" + Integration.name]: Integration.isIntegration()
				})}"
				data-annotation-uuid="${uuid}"
				data-annotation-type="image"
				data-topic-uuid="${this.topic?.uuid}"
			>
				<pn-annotation-header
					.annotation="${annotation}"
					.topic="${this.topic}"
					sortBy="${this.sortBy}"
				></pn-annotation-header>

				<div
					class="thumbnail-notes-btn dotted-focus-outline"
				>
					${this.getThumbnail()}
				</div>

				<div
					class="${classMap({
						"pn-notes": true,
						"editable": editable,
						"empty":    noteContent === "<p></p>"
					})}"
					.onClick="${() => openImageAnnotation(uuid)}"
				>
					${(noteContent !== "<p></p>" && noteContent !== "")
						? unsafeHTML(noteContent)
						: html`<span class="placeholder">
							${editable ? "+ Note" : "Click for full size image"}
						</span>`}
				</div>

				<pn-annotation-footer
					.annotation="${this.annotation}"
					.isEditable=${this.isEditable}
					.loadProjectTopics="${this.loadProjectTopics}"
					.mode="${this.mode}"
					.onClickPageLink="${(event) => this.onClickPageLink(event, this.annotation.uuid)}"
					.onDeleteAnnotation="${this.onDeleteAnnotation}"
					.onUpdateAnnotationTopic="${this.onUpdateAnnotationTopic}"
					.projects="${this.projects}"
					.projectTopicsUrl="${this.projectTopicsUrl}"
					.topics="${this.topics}"
				></pn-annotation-footer>
			</div>
		`;
	}
};

declare global {
	interface HTMLElementTagNameMap {
		"pn-annotation-image": AnnotationImage;
	}
}
